<div class="container" aria-modal="true">
  <div mat-dialog-title class="dialog-title">
    <h1 mat-dialog-title>
      Image Preview
    </h1>
    <button mat-icon-button aria-label="close dialog" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div>
    <mat-dialog-content class="dialog-content">
      <div *ngIf="thumbnail">
        <div class="image-container" #viewer>
          <img class="thumbnail"
               #img
               [src]="thumbnail.image"
               [alt]="thumbnail.name"
               style="transform-origin: 0 0;display: block;"
               data-pdfmake='{"widths": [100, "*", "auto"], "heights": 40}'
               (load)="onImageLoad($event)"
          >
        </div>
      </div>

    </mat-dialog-content>
    <div class="display-flex flex-justify tablet:margin-105">
      <div class="caption" >
        <i>{{ thumbnail?.caption ?? '' }}</i>
      </div>
      <div class="margin-right-1">
        <ul class="usa-button-group">
          <li class="usa-button-group__item">
            <button
              type="button"
              class="usa-button usa-button--secondary fa-icon-button"
              (click)="downloadImage()"
              matTooltip="Download Image"
              matTooltipClass="tooltipClass"
            >
              <fa-icon
                class="fa-solid"
                [icon]="faDownload"
              ></fa-icon>
            </button>
          </li>
          <li class="usa-button-group__item">
            <button
              type="button"
              class="usa-button usa-button--secondary ma-icon-button"
              (click)="zoomIn()"
              matTooltip="Zoom In"
              matTooltipClass="tooltipClass"
            >
              <mat-icon>zoom_in</mat-icon>
            </button>
          </li>
          <li class="usa-button-group__item">
            <button
              type="button"
              class="usa-button usa-button--secondary ma-icon-button"
              (click)="zoomOut()"
              matTooltip="Zoom Out"
              matTooltipClass="tooltipClass"
            >
              <mat-icon>zoom_out</mat-icon>
            </button>
          </li>
          <li class="usa-button-group__item">
            <button
              type="button"
              class="usa-button usa-button--secondary fa-icon-button"
              (click)="toggleFitFull()"
              [matTooltip]="mode === 'full' ? 'Fit Width' : 'Actual Size'"
              matTooltipClass="tooltipClass"
            >
              <fa-icon
                class="fa-solid"
                [icon]="mode === 'full' ? faDownLeftAndUpRightToCenter : faUpRightAndDownLeftFromCenter"
              ></fa-icon>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
